import type { JsonTokenType } from "./jsonValue";

/** Text colour of each kind of JSON token, in the text view and the tree view alike (the brand palette). */
export const JSON_TOKEN_CLASS: Record<JsonTokenType, string> = {
  key: "text-gray-700 dark:text-dark-200",
  string: "text-primary-700 dark:text-primary-300",
  number: "text-orange-600 dark:text-orange-300",
  boolean: "text-blue-600 dark:text-blue-300",
  null: "text-purple-500 dark:text-purple-300",
  punctuation: "text-gray-400 dark:text-dark-400",
  whitespace: "",
  other: "text-red-600 dark:text-red-400",
};
